export default "__VITE_ASSET__DK7A3Awu__"